import React, { useState } from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Services
import {
  FileResponse,
  geBasketPercentageBasedOnAssets,
  getUserPositionExcelFile,
} from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import {
  IUserPositionSummarySearchParams,
  IUserPositionSummaryTableReport,
} from "src/Interfaces/imePortfolio";
import PortfoTableSection from "./PortfoTableSection";
interface IProps {
  searchParams: IUserPositionSummarySearchParams;
  totalRefreshFlag: boolean;
}

const BasketPercentageBasedOnAssets = ({ searchParams, totalRefreshFlag }: IProps) => {
  return (
    <PortfoTableSection title="تسهیم سبد بر مبنای دارایی پایه">
      <TableTemplate<
        IUserPositionSummarySearchParams,
        IUserPositionSummaryTableReport
      >
        getDataTable={geBasketPercentageBasedOnAssets}
        tableWrapperClassname="w-full justify-start"
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
            tableHeaderClassName="!bg-sky-50 hover:!bg-sky-100"
            onAction={onAction}
            refreshFlag={totalRefreshFlag}
          />
        )}
        withSort
        searchParameters={searchParams}
      />
    </PortfoTableSection>
  );
};

export default BasketPercentageBasedOnAssets;
